module.exports = __webpack_public_path__ + "img/OneDrive.b65dbcd6.png";